import { useCatalogue } from '../../../hooks/use-catalogue';
import { containerSizesApi } from '../container-sizes.api';

export const useContainerSizes = () => useCatalogue(containerSizesApi, { conflictMessage: 'A container size with this code already exists.' });
